import { useCallback } from 'react';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import EditCsmModal from './EditCsmModal';

export const useEditCsmModal = () => {
  const { openModal } = useDynamicModal();

  const openEditCsmModal = useCallback(
    ({ teamId }: { teamId: number }) => {
      openModal({ modal: ({ toggle }) => <EditCsmModal teamId={teamId} onClose={toggle} /> });
    },
    [openModal],
  );

  return { openEditCsmModal };
};

export default useEditCsmModal;
